import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent),
  },
  {
    path: 'packages',
    loadComponent: () => import('./pages/packages/packages.component').then(m => m.PackagesComponent),
  },
  {
    path: 'request-demo',
    loadComponent: () =>
      import('./pages/request-demo/request-demo.component').then(m => m.RequestDemoComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent),
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout/checkout.component').then(m => m.CheckoutComponent),
  },
  {
    path: 'welcome',
    loadComponent: () => import('./pages/welcome/welcome.component').then(m => m.WelcomeComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'verify-email',
    loadComponent: () =>
      import('./pages/verify-email/verify-email.component').then(m => m.VerifyEmailComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./pages/legal/legal-document.component').then(m => m.LegalDocumentComponent),
    data: { legalType: 'terms' },
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/legal/legal-document.component').then(m => m.LegalDocumentComponent),
    data: { legalType: 'privacy' },
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./pages/support/support.component').then(m => m.SupportComponent),
  },
  {
    path: 'portal',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/portal/portal-shell.component').then(m => m.PortalShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/portal/dashboard/dashboard.component').then(m => m.PortalDashboardComponent),
      },
      {
        path: 'docs',
        loadComponent: () =>
          import('./pages/portal/docs/docs.component').then(m => m.PortalDocsComponent),
      },
      {
        path: 'setup',
        loadComponent: () =>
          import('./pages/portal/docs/docs.component').then(m => m.PortalDocsComponent),
      },
      {
        path: 'tutorials',
        loadComponent: () =>
          import('./pages/portal/docs/docs.component').then(m => m.PortalDocsComponent),
      },
      {
        path: 'support',
        loadComponent: () =>
          import('./pages/portal/docs/docs.component').then(m => m.PortalDocsComponent),
      },
      {
        path: 'account',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'information' },
          {
            path: 'information',
            loadComponent: () =>
              import('./pages/account/account-information.component').then(
                m => m.AccountInformationComponent,
              ),
          },
          {
            path: 'password',
            loadComponent: () =>
              import('./pages/account/account-password.component').then(m => m.AccountPasswordComponent),
          },
          {
            path: 'mobile-setup',
            loadComponent: () =>
              import('./pages/account/mobile-setup/mobile-setup.component').then(
                m => m.MobileSetupComponent,
              ),
          },
        ],
      },
      {
        path: 'billing',
        loadComponent: () =>
          import('./pages/billing/billing.component').then(m => m.BillingComponent),
      },
    ],
  },
  { path: 'account', redirectTo: 'portal/account/information', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];
